import * as React from 'react';
import s from './Enterprise.scss';
import { EnterpriseBanner } from './EnterpriseBanner';
import { EnterpriseTabContextProvider } from 'providers/EnterpriseContextProvider';
import { EnterpriseFeatures } from './EnterpriseFeatures';
import { EnterpriseFormSection } from './EnterpriseFormSection';
import { EnterpriseHeader } from './EnterpriseHeader';
import { Faq, FaqType } from '../../../components/Faq/Faq';
import { observer } from 'mobx-react';
import { RootStore, withInjectedRootStore } from 'providers';
import { NoTabsBanner } from '../PaymentBanners';

export interface EnterpriseTabProps {
  rootStore: RootStore;
}
const EnterpriseTabComp: React.FC<EnterpriseTabProps> = ({ rootStore }) => {
  const { shouldStoreIntentNoTabs, jumpToTab } = rootStore.appStore;
  return (
    <EnterpriseTabContextProvider>
      <section className={s.enterpriseTabContainer}>
        {shouldStoreIntentNoTabs && <NoTabsBanner action={jumpToTab} />}
        <div>
          <EnterpriseHeader />
          <EnterpriseBanner />
        </div>
        <EnterpriseFeatures />
        <EnterpriseFormSection />
        <Faq faqType={FaqType.Enterprise} />
      </section>
    </EnterpriseTabContextProvider>
  );
};

export const EnterpriseTab = withInjectedRootStore(observer(EnterpriseTabComp));
